module.exports = __webpack_public_path__ + "static/img/charge5.cfa34ee7.png";